import React from "react";

const Tabs = ({ setActiveOption, tabs, activeTab, setActiveTab }) => {
  return (
    <>
      {tabs.length ? (
        <div className=" bg-zinc-900 gap-1  p-1 flex max-w-fit rounded-lg mt-3 mb-2">
          {tabs.map((tab, index) => {
            return (
              <div
                className="flex gap-1 items-center"
                key={tab.tabName}
                onClick={() => {
                  setActiveTab(tab);
                  setActiveOption(null);
                }}
              >
                <div
                  className={` px-4 py-1.5 text-xs  duration-150 cursor-pointer ${
                    activeTab === tab
                      ? "bg-zinc-700 hover:bg-zinc-700 rounded-md"
                      : "hover:bg-zinc-800 rounded-lg"
                  }`}
                >
                  {tab.tabName}
                </div>
                {index !== tabs.length - 1 ? (
                  <div className="h-4/5 w-[1px] bg-zinc-800"></div>
                ) : null}
              </div>
            );
          })}
        </div>
      ) : null}
    </>
  );
};

export default Tabs;
